import { SelectOption } from "components/dropdown/Dropdown";
import { customField } from "components/helpers/CustomFieldRenderers/CustomFormFields/model";

export type ProjectManagementListData = {
  projects__ID: number;
  projects__ProjectsName: string;
  projects__TasksCompleted: number;
  projects__TotalTasks: number;
  siteDetails__Address: string;
  gateways__GatewaysName: string;
  projects__CurrentMilestone: string;
  projectStatusTypes__Status: string;
  projectTypes__Type: string;
  projects__bActive: boolean;
  projects__AddDate: string;
  projects__AddedBy: string;
  projects__EditDate: string;
  projects__LastEditedBy: string;
  programmes__Name: string;
  projects__CompletedGateways: number;
  projects__TotalGateways: number;
  sites__SitesName: string | null;
  sites__ID: number;
  sites__Region: string;
  sites__ClientID: string | null;
};

export interface ProjectManagementProps {}

export type ProjectManagementListProps = ProjectManagementProps;

export enum TaskType {
  MILESTONE = "Milestone",
  STANDARD_TASK = "StandardTask",
  CUSTOM_TASK = "CustomTask",
}

export enum TaskResult {
  N_A = "N_A",
  NO = "No",
  YES = "Yes",
}

export interface Task {
  taskInstancesID: number;
  taskTemplatesID: number;
  taskName: string;
  description: string;
  bHeaderTask: boolean;
  taskType: TaskType;
  completedBy: string | null;
  completedDate: string;
  bComplete: boolean;
  orderNumber: number;
  // Milestones
  bPlannedActive: boolean;
  bPlannedReadOnly: boolean;
  plannedDate: string | null;
  bForecastActive: boolean;
  bForecastReadOnly: boolean;
  forecastDate: string | null;
  bActualActive: boolean;
  actualDate: string | null;
  bActualReadOnly: boolean;
  // Standard Task Result
  taskResult: TaskResult | null;
  // Custom Task
  customFields: customField[];
  // Lists
  contactTypes: SelectOption[];
  documentTypes: SelectOption[];
  siteUsers: SelectOption[];
}

/**
 * Gateway Interface
 */
export interface Gateway {
  siteAddress: string | null;
  siteName: string | null;
  siteID: number | null;
  projectID: number | null;
  clientID: number | null;
  completedTasksCount: number;
  tasksCount: number;
  description: string;
  orderNumber: number;
  gatewayName: string;
  gatewaysID: number;
  gatewayTemplateID: number;
  bComplete: boolean;
  bEditable: boolean;
  bAllowPrintPDF: boolean;
  tasks: Task[];
  taskHeadersID: number | null;
  taskHeaderInstancesID: number | null;
  bGatewayNAEnabled: boolean;
  bGatewayNAValue: boolean;
  bGatewayNALocked: boolean;
}
